import React, { useState, useCallback, useEffect } from "react";

import {
    Box,
    Button,
    Divider,
    TextField,
    Grid,
    Card,
    styled,
    Typography,
    IconButton,
    List,
    ListItem,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    ListItemText,
    FormHelperText
} from '@mui/material';

import { grey, red } from "@mui/material/colors";

import { useFormik } from 'formik';

import CommonSectionHeader from "../../../../../../components/common/CommonSectionHeader"
import { useAppContextFeatures } from "../../../../../../context/AppContext"
import { useSystemPrompt } from "../../../../../../hooks/useSystemPrompt";
import { useTranslations } from "../../../../../../hooks/useTranslations";

import { useAuthAccess } from "../../../../../../hooks/useAuthAccess"

import {
    // productLoadStatusTypes,
    // paymentTypes as productPaymentTypes,
    useProduct,
    initialItemValues,
    validateItemSchema,
    calculateCbmByDimension,
    productInjectionFields,
    productLoadStatusTypes
} from "../../../../hooks/model/useProduct";

import {
    useProductItem,
    itemInjectionFields,
    itemUoms
} from "../../../../hooks/model/useProductItem"

import {
    useContainerSummary,
} from "../../../../hooks/model/useContainerSummary"

import { checkValueExists } from "../../../../../../utils/dataSchema"

import { getInjectionDataType } from "../../../../utils/injectionSelection";

import { formatRoundValue } from "../../../../utils/formatNumber";

export const validationSchema = validateItemSchema

export const initialValues = initialItemValues

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));


const StyledBox = styled(Box)(({ theme }) => ({
    padding: 1
}));

export default function UpdateProductItem({
    routeType,
    itemId,
    productId,
    handleOnSuccess = () => { }
}) {

    const { t } = useTranslations({ ns: ["_@products", "_prompt", "_@repositories", "_@parcel", "common", "_common"] })

    const { promptMessage } = useSystemPrompt();

    const { authData } = useAuthAccess(routeType)

    const { setSystemLoading } = useAppContextFeatures();

    const { getProduct, listProducts, updateLastUpdateProduct, checkProductIsLoadedContainer } = useProduct({ routeType })
    const { updateProductItem: _updateProductItem, getProductItem, filterOperatorTypes } = useProductItem({ routeType })
    const { updateContainerSummary } = useContainerSummary({ routeType })

    const [savedData, setSavedData] = useState()

    const [summaryItems, setSummaryItems] = useState([])

    const authDataUserId = `${authData?.profile?.user?.id}`
    const authDataUserDisplay = `${authData?.profile?.user?.username}`

    const loadData = async (id) => {

        setSystemLoading(true);

        try {

            let dataTypesArray = [`${getInjectionDataType('item')}`]

            let data = await getProductItem({ id, dataTypesArray })

            let dataSource = data?.item ? data.item : {}

            let productSource = await fetchProduct({ productId })

            // console.log('dataSource', dataSource)

            let savedData = {
                ...initialItemValues,

                userId: dataSource[itemInjectionFields.customerUserId.retrieveKey],
                userMarking: dataSource[itemInjectionFields.customerMarking.retrieveKey],
                userBranchId: dataSource[itemInjectionFields.customerBranchId.retrieveKey],

                code: dataSource?.code,
                description: dataSource?.item_description,
                remark: dataSource?.item_remark,
                uomId: dataSource?.uom_id,
                uomPrice: dataSource?.uom_price,
                uomDisplay: dataSource?.uom_name,
                length: dataSource?.dimension_length,
                height: dataSource?.dimension_height,
                width: dataSource?.dimension_width,
                weight: dataSource?.net_weight,
                cbm: dataSource?.cbm,
                qty: dataSource[itemInjectionFields.packQty.retrieveKey],
                handleQty: dataSource[itemInjectionFields.handleQty.retrieveKey],
                handleQtyPerPackage: dataSource[itemInjectionFields.qtyPerPackage.retrieveKey],
                totalValue: dataSource[itemInjectionFields.totalValue.retrieveKey],
                totalCbm: dataSource[itemInjectionFields.totalCbm.retrieveKey],
                totalWeight: dataSource[itemInjectionFields.totalWeight.retrieveKey],

                [`${itemInjectionFields.uomName.submitKey}`]: dataSource[itemInjectionFields.uomName.retrieveKey],

                sourceItemRemId: dataSource[itemInjectionFields.sourceItemRemId.retrieveKey],

                // optional
                scanningCodeSuffix: dataSource?.scanning_code_suffix
            }

            savedData = {
                ...savedData,
                // handleQty: parseFloat(savedData?.handleQty).toFixed(0),
                handleQty: parseFloat(savedData?.handleQty),
                length: parseFloat(savedData?.length).toFixed(2),
                height: parseFloat(savedData?.height).toFixed(2),
                width: parseFloat(savedData?.width).toFixed(2),
                weight: parseFloat(savedData?.weight).toFixed(4),
                qty: parseFloat(savedData?.qty).toFixed(0),
                handleQtyPerPackage: parseFloat(savedData?.handleQtyPerPackage).toFixed(0),
                loadStatus: productSource[productInjectionFields.loadStatus.retrieveKey],
                registerLocationId: productSource[productInjectionFields.registerLocationId.retrieveKey],
            }

            // console.log('savedData', savedData)

            setSavedData(savedData)

            setSystemLoading(false)

            return true

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)
        return false

    }

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            let sourceItemRemId = values?.sourceItemRemId

            if (!sourceItemRemId) {
                throw Error(`sourceItemRemId is Required`)
            }

            let payload = {
                itemId,
                sourceItemRemId,
                registerLocationId: values?.registerLocationId,
                item: {
                    userMarking: currentValues?.userMarking,
                    userBranchId: currentValues?.userBranchId,
                    userId: currentValues?.userId,
                    code: currentValues?.code,
                    uomId: currentValues?.uomId,
                    itemDescription: currentValues?.description,
                    remark: currentValues?.remark,
                    uomPrice: currentValues?.uomPrice,
                    netWeight: parseFloat(currentValues?.weight).toFixed(4),
                    width: parseFloat(currentValues?.width).toFixed(2),
                    height: parseFloat(currentValues?.height).toFixed(2),
                    length: parseFloat(currentValues?.length).toFixed(2),

                    qty: currentValues?.qty,
                    handleQty: currentValues?.handleQty,
                    handleQtyPerPackage: currentValues?.handleQtyPerPackage,
                    uomName: currentValues[itemInjectionFields.uomName.submitKey],

                    cbm: parseFloat(summaryItems?.cbm),
                    totalWeight: parseFloat(summaryItems?.totalWeight),
                    totalValue: parseFloat(summaryItems?.totalValue),
                    totalCbm: parseFloat(summaryItems?.totalCbm)
                }
            }

            // console.log('payload', payload)

            await _updateProductItem(payload)

            let _p = {
                productId,
                lastUpdateUserId: authDataUserId,
                lastUpdateUserDisplay: authDataUserDisplay
            }

            await updateLastUpdateProduct(_p)

            // check product loaded to container
            let responseLoadedContainer = await checkProductIsLoadedContainer({ productId })

            let loadContainerId = responseLoadedContainer?.loadContainerId
            let loadContainerStatus = responseLoadedContainer?.loadContainerStatus

            if (loadContainerStatus === productLoadStatusTypes.loaded.id) {
                updateContainerSummary({ containerId: loadContainerId, listProducts })
            }

            setSystemLoading(false)

            if (handleOnSuccess) {
                handleOnSuccess()
            }

            promptMessage(true, `${t("savedSuccess")}`)

        } catch (error) {

            promptMessage(false, `${error?.message}`)

        }

        setSystemLoading(false)
        return true

    }

    const fetchProduct = async ({ productId }) => {

        try {

            let dataTypesArray = [`${getInjectionDataType('product')}`, `${getInjectionDataType('item')}`]

            const data = await getProduct({ id: productId, dataTypesArray })

            const _data = data?.product ? data.product : {}

            // setDataProduct(_data)

            return _data

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        return false

    }

    const formik = useFormik({
        initialValues: savedData,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue, setValues } = formik;

    useEffect(() => {

        loadData(itemId)

    }, [])

    useEffect(() => {

        if (values) {

            let currentItems = values
            let newItems = []

            // const divideNo = 1000000

            let {
                uomPrice = '',
                handleQty = '',
                qty = '',
                weight = '',
                width = '',
                height = '',
                length = ''
            } = currentItems

            let unitPrice = parseFloat(uomPrice)
            handleQty = parseFloat(handleQty)
            qty = parseFloat(qty)
            // net_weight is stored at 4dp, so the total must derive from that same value
            weight = formatRoundValue(parseFloat(weight), 4)

            width = parseFloat(width)
            height = parseFloat(height)
            length = parseFloat(length)

            let value = unitPrice * handleQty

            let totalValue = parseFloat(value)

            let cbm = calculateCbmByDimension({ w: width, h: height, l: length })

            let totalCbm = cbm * qty
            let totalWeight = weight * qty

            if (Number.isNaN(totalValue)) totalValue = 0
            if (Number.isNaN(totalCbm)) totalCbm = 0
            if (Number.isNaN(totalWeight)) totalWeight = 0
            if (Number.isNaN(totalCbm)) totalCbm = 0

            newItems = {
                cbm: parseFloat(cbm).toFixed(4),
                totalValue: parseFloat(totalValue).toFixed(2),
                totalCbm: parseFloat(totalCbm).toFixed(4),
                totalWeight: parseFloat(totalWeight).toFixed(4),
            }

            setSummaryItems(newItems)
        }

    }, [values])

    const RenderForm = () => {

        if (!values) return <></>

        let uomValue = ''

        // getting the uom name
        let a = itemUoms.filter(i => i.translation.includes(values[itemInjectionFields.uomName.submitKey]) === true)

        // console.log('aa', values[itemInjectionFields.uomName.submitKey], itemUoms, a)

        if (a.length > 0) {

            // console.log('a[0].value', a[0].value)

            uomValue = t(a[0].display)
        }

        return (

            <form onSubmit={formik.handleSubmit}>

                <Box
                    sx={{
                        p: 2
                    }}
                >
                    <Grid container spacing={1}>

                        <Grid item xs={12} sm={12} md={2} alignSelf={"flex-start"}>

                            <CommonSectionHeader
                                title={t('item')}
                                subTitle={t('updateItemInformation')}
                            />
                            <Divider
                                sx={{
                                    my: 1
                                }}
                            />
                            <Typography
                                sx={{
                                    fontSize: 12
                                }}
                            >
                                {`${t('itemCode')} : ${values?.code}`}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: 12
                                }}
                            >
                                {`${t('scanningSuffix')} : ${values?.scanningCodeSuffix}`}
                            </Typography>
                            <Divider
                                sx={{
                                    my: 1
                                }}
                            />
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: grey[500]
                                }}
                            >
                                {`sourceItemRemId : ${values?.sourceItemRemId}`}
                            </Typography>


                        </Grid>

                        <Grid item xs={12} sm={12} md={10} alignSelf={"center"}>
                            <Grid container spacing={1}>

                                <Grid item xs={12} sm={12} md={6} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`remark`}
                                        label={t('model')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.remark ? values.remark : ""}
                                        onChange={handleChange}
                                        error={Boolean(errors?.remark)}
                                    // helperText={errors?.remark}
                                    />

                                </Grid>

                                <Grid item xs={12} sm={12} md={6} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`description`}
                                        label={t('itemName')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.description ? values.description : ""}
                                        onChange={handleChange}
                                        error={Boolean(errors?.description)}
                                    // helperText={errors?.description}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`handleQty`}
                                        label={t('handleQty')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.handleQty ? values.handleQty : ""}
                                        // onChange={handleChange}
                                        onChange={(e) => {

                                            let val = e.target.value

                                            setFieldValue(`handleQty`, val)

                                            // setNeedRecalculate(true)

                                        }}
                                        error={Boolean(errors?.handleQty)}
                                    // helperText={errors?.handleQty}
                                    />

                                </Grid>
                                <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`uomPrice`}
                                        label={t('unitPrice')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.uomPrice ? values.uomPrice : ""}
                                        // onChange={handleChange}
                                        onChange={(e) => {

                                            let val = e.target.value

                                            setFieldValue(`uomPrice`, val)

                                            // setNeedRecalculate(true)

                                        }}
                                        error={Boolean(errors?.uomPrice)}
                                    // helperText={errors?.uomPrice}
                                    />

                                </Grid>

                                <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`handleQtyPerPackage`}
                                        label={t('pcsCtn')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.handleQtyPerPackage ? values.handleQtyPerPackage : ""}
                                        onChange={handleChange}
                                        error={Boolean(errors?.handleQtyPerPackage)}
                                    // helperText={errors?.remark}
                                    />

                                </Grid>

                                <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                                    {/* {values[itemInjectionFields.uomName.submitKey]} */}
                                    {/* {JSON.stringify(itemUoms)} */}
                                    <FormControl
                                        margin="dense"
                                        fullWidth
                                        size="small"
                                    >
                                        <InputLabel id="uomName">{t('uom')}</InputLabel>
                                        <Select
                                            labelId="uomName"
                                            label="uomName"
                                            name={'uomName'}
                                            onChange={(event) => {
                                                setFieldValue(`${itemInjectionFields.uomName.submitKey}`, event.target.value);
                                            }}
                                            // value={checkValueExists({
                                            //     dataSearch: itemUoms,
                                            //     valueToCompare: values[itemInjectionFields.uomName.submitKey],
                                            //     searchFieldId: `value`
                                            // })}
                                            value={uomValue}
                                            sx={{
                                                textAlign: 'left',
                                            }}
                                        >
                                            {itemUoms.map((i, index) => {
                                                return (
                                                    <MenuItem key={index} value={t(i.display)}>
                                                        {t(i.display)}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                        {/* <FormHelperText>{touched.businessId && errors.businessId}</FormHelperText> */}
                                    </FormControl>

                                </Grid>

                                <Grid item xs={12} sm={12} md={4} alignSelf={"center"}>
                                    <></>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`length`}
                                        label={t('length')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.length ? values.length : ""}
                                        // onChange={handleChange}
                                        onChange={(e) => {

                                            let val = e.target.value

                                            setFieldValue(`length`, val)

                                            // setNeedRecalculate(true)

                                        }}
                                        error={Boolean(errors?.length)}
                                    // helperText={errors?.paymentType}
                                    />

                                </Grid>

                                <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`width`}
                                        label={t('width')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.width ? values.width : ""}
                                        // onChange={handleChange}
                                        onChange={(e) => {

                                            let val = e.target.value

                                            setFieldValue(`width`, val)

                                            // setNeedRecalculate(true)

                                        }}
                                        error={Boolean(errors?.width)}
                                    // helperText={errors?.width}
                                    />

                                </Grid>

                                <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`height`}
                                        label={t('height')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.height ? values.height : ""}
                                        // onChange={handleChange}
                                        onChange={(e) => {

                                            let val = e.target.value

                                            setFieldValue(`height`, val)

                                            // setNeedRecalculate(true)

                                        }}
                                        error={Boolean(errors?.height)}
                                    // helperText={errors?.height}
                                    />

                                </Grid>

                                <Grid item xs={12} sm={12} md={6} alignSelf={"center"}>
                                    <></>
                                </Grid>

                                <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`qty`}
                                        label={t('packUnit')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.qty ? values.qty : ""}
                                        // onChange={handleChange}
                                        onChange={(e) => {

                                            let val = e.target.value

                                            setFieldValue(`qty`, val)

                                            // setNeedRecalculate(true)

                                        }}
                                        error={Boolean(errors?.qty)}
                                    // helperText={errors?.qty}
                                    />

                                </Grid>

                                <Grid item xs={12} sm={12} md={2} alignSelf={"center"}>

                                    <TextField
                                        margin="dense"
                                        size="small"
                                        // autoFocus
                                        fullWidth
                                        name={`weight`}
                                        label={t('weight')}
                                        type="text"
                                        variant="outlined"
                                        value={values?.weight ? values.weight : ""}
                                        // onChange={handleChange}
                                        onChange={(e) => {

                                            let val = e.target.value

                                            setFieldValue(`weight`, val)

                                            // setNeedRecalculate(true)

                                        }}
                                        error={Boolean(errors?.weight)}
                                    // helperText={errors?.weight}
                                    />

                                </Grid>


                                <Grid item xs={12} sm={12} md={8} alignSelf={"center"}>
                                    <></>
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} alignSelf={"center"}>
                                    <Divider />
                                </Grid>

                                <Grid item xs={12} sm={12} md={6} alignSelf={"center"}>
                                    <></>
                                </Grid>

                                <Grid item xs={12} sm={12} md={6} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>

                                    <StyledBox>
                                        <Typography
                                            sx={{
                                                fontSize: 10
                                            }}
                                        >
                                            {`${t('tValue')} : `}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: 14
                                            }}
                                        >
                                            {` ${summaryItems?.totalValue ? summaryItems.totalValue : 0}`}
                                        </Typography>
                                    </StyledBox>


                                    <StyledBox>
                                        <Typography
                                            sx={{
                                                fontSize: 10
                                            }}
                                        >
                                            {`${t('cbm')} : `}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: 14
                                            }}
                                        >
                                            {` ${summaryItems?.cbm ? summaryItems.cbm : 0}`}
                                        </Typography>
                                    </StyledBox>

                                    <StyledBox>
                                        <Typography
                                            sx={{
                                                fontSize: 10
                                            }}
                                        >
                                            {`${t('tCbm')} : `}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: 14
                                            }}
                                        >
                                            {` ${summaryItems?.totalCbm ? summaryItems.totalCbm : 0}`}
                                        </Typography>
                                    </StyledBox>


                                    <StyledBox>
                                        <Typography
                                            sx={{
                                                fontSize: 10
                                            }}
                                        >
                                            {`${t('tWeight')} : `}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                fontSize: 14
                                            }}
                                        >
                                            {` ${summaryItems?.totalWeight ? summaryItems.totalWeight : 0}`}
                                        </Typography>
                                    </StyledBox>

                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </Box>

                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        {/* {
                            values?.loadStatus === productLoadStatusTypes.loaded.value ?
                            (
                                <Typography
                                    sx={{
                                        color: red[500],
                                        fontSize: 14
                                    }}
                                >
                                    Not allowed to change once loaded to container
                                </Typography>
                            )
                            :
                            ( */}
                        <Button
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                        >
                            {t('saveChanges')}
                        </Button>
                        {/* )
                        } */}
                    </Grid>
                </Grid>
            </form >

        )
    }

    return (
        <Box>

            {/* {JSON.stringify(values)} */}

            {
                RenderForm()
            }

        </Box>
    )
}